import React from 'react';
import { ArrowDownWideNarrow, ArrowUpWideNarrow } from 'lucide-react';
import styles from './SortOrderToggle.module.css';

export type SortOrder = 'newest' | 'oldest';

interface SortOrderToggleProps {
  value: SortOrder;
  onChange: (value: SortOrder) => void;
}

export function SortOrderToggle({ value, onChange }: SortOrderToggleProps) {
  const isNewest = value === 'newest';
  return (
    <button
      type="button"
      className={styles.sortBtn}
      onClick={() => onChange(isNewest ? 'oldest' : 'newest')}
      title={isNewest ? 'Showing newest first' : 'Showing oldest first'}
    >
      {isNewest ? <ArrowDownWideNarrow size={16} /> : <ArrowUpWideNarrow size={16} />}
      {isNewest ? 'Newest first' : 'Oldest first'}
    </button>
  );
}
